export class VaultTieringPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "VaultTieringPolicyType",
            "format": ""
        },
        {
            "name": "configuration",
            "baseName": "configuration",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultTieringPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
